/*
 * @Author: liuhuazhou liuhuazhou@xiaomi.com
 * @Date: 2024-08-19 10:02:18
 * @LastEditors: liuhuazhou liuhuazhou@xiaomi.com
 * @LastEditTime: 2024-08-19 11:21:47
 * @FilePath: /RetailApp/retail-global-h5/src/pages/RetailGlobal/Protocol/PrivacyNotice/id-ID/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * 捷克语
 */
import React, { memo, useEffect } from 'react';
import globalStyles from '../../../../global.less';
import styles from './index.less';

var HTML_CONTENT = ""
HTML_CONTENT += `
    <html>
        <body>
            <div>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial">
                        Aby poinformować Cię o dostępności przedsprzedaży w naszym sklepie oraz zweryfikować Twoje zamówienie przy odbiorze, Xiaomi będzie zbierać 
                        <strong>Twoje imię i adres e-mail. </strong>
                        Kod odbioru zostanie wysłany na ten adres e-mail. Podstawą prawną przetwarzania Twoich danych osobowych jest 
                        <strong>konieczność wykonania umowy, której jesteś stroną.</strong>
                    </span>
                </p>
                <p style="margin-top:6pt; margin-bottom:6pt; line-height:180%">
                    <span style="font-family:Arial"> Możesz skorzystać ze swoich praw w zakresie ochrony danych osobowych (np. dostępu, sprostowania i/lub usunięcia danych) za pośrednictwem naszej Platformy Wsparcia Prywatności: 
                        <a href="https://privacy.mi.com/support/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/support/</span>
                        </a> 
                        Zapoznaj się z naszą Polityką Prywatności: 
                        <a href="https://privacy.mi.com/all/languages/" style="text-decoration:none">
                            <span style="font-family:Arial; color:#3370ff">https://privacy.mi.com/all/languages/</span>
                        </a>
                        , aby uzyskać więcej informacji na temat przetwarzania Twoich danych osobowych.
                    </span>
                </p>
            </div>
        </body>
    </html>`;

    
function ProtocolPage() {

    useEffect(() => {
    }, []);

    // 一个用于渲染html的函数组件
    const renderHtml = (html: string) => {
        return <div dangerouslySetInnerHTML={{ __html: html }} />;
    };

    return (
        <div className={[globalStyles['container'], styles['viewport']].join(' ')}>
            {renderHtml(HTML_CONTENT)}
        </div>
    )
}

export default memo(ProtocolPage)